import { render, staticRenderFns } from "./store.vue?vue&type=template&id=ddc49b8c&scoped=true"
import script from "./store.vue?vue&type=script&lang=js"
export * from "./store.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddc49b8c",
  null
  
)

export default component.exports